var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"phone-simulator",style:(this.type==1?'width:auto;height:auto':null)},[_c('iframe',{attrs:{"src":_vm.iframeSrc,"frameborder":"0"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }